const PLAN_TIER_TAGLINE_EN = {
  basic:
    'Essential identity protection for individuals seeking foundational coverage.',
  value:
    'Comprehensive identity protection with extensive monitoring for peace of mind.',
  total:
    'Advanced identity protection designed for individuals focused on credit information.',
  complete:
    'Robust identity protection with added tools for broader digital security.',
  premier:
    'Powerful protection featuring the latest innovations in online safety.',
  ultimate:
    'Our most complete coverage, combining advanced identity and privacy protection.',
} as const;

function tierTaglineFromNormalizedTier(tierNormalized: string): string {
  switch (tierNormalized) {
    case 'value essential':
    case 'value':
      return PLAN_TIER_TAGLINE_EN.value;
    case 'total plus':
    case 'total':
      return PLAN_TIER_TAGLINE_EN.total;
    case 'premier complete':
    case 'premier':
      return PLAN_TIER_TAGLINE_EN.premier;
    case 'complete':
      return PLAN_TIER_TAGLINE_EN.complete;
    case 'ultimate':
      return PLAN_TIER_TAGLINE_EN.ultimate;
    case 'basic':
      return PLAN_TIER_TAGLINE_EN.basic;
    default:
      return '';
  }
}

export function inferPlanTierSlugFromPlanName(
  planName: string | null | undefined,
): string {
  if (!planName?.trim()) return '';
  const n = planName.trim().toLowerCase();
  if (n.includes('premier complete')) return 'premier complete';
  if (/\bultimate\b/.test(n)) return 'ultimate';
  if (/\bpremier\b/.test(n)) return 'premier';
  if (/\bcomplete\b/.test(n)) return 'complete';
  if (n.includes('total plus')) return 'total plus';
  if (/\btotal\b/.test(n)) return 'total';
  if (/\bvalue essential\b/.test(n)) return 'value essential';
  if (/\bvalue\b/.test(n)) return 'value';
  if (/\bbasic\b/.test(n)) return 'basic';
  return '';
}

export function taglineForTierSlug(slug: string): string {
  switch (slug) {
    case 'premier complete':
    case 'premier':
      return PLAN_TIER_TAGLINE_EN.premier;
    case 'ultimate':
      return PLAN_TIER_TAGLINE_EN.ultimate;
    case 'complete':
      return PLAN_TIER_TAGLINE_EN.complete;
    case 'total plus':
    case 'total':
      return PLAN_TIER_TAGLINE_EN.total;
    case 'value essential':
    case 'value':
      return PLAN_TIER_TAGLINE_EN.value;
    case 'basic':
      return PLAN_TIER_TAGLINE_EN.basic;
    default:
      return '';
  }
}

export function getPlanTierTaglineEn(tier: string | null | undefined): string {
  if (!tier?.trim()) return '';
  return tierTaglineFromNormalizedTier(tier.trim().toLowerCase());
}

export default function resolvePlanCardDescription(
  tier: string | null | undefined,
  planName: string | null | undefined,
): string {
  const fromTier = getPlanTierTaglineEn(tier);
  if (fromTier) return fromTier;
  const slug = inferPlanTierSlugFromPlanName(planName);
  return slug ? taglineForTierSlug(slug) : '';
}
